// extracted by mini-css-extract-plugin
export default {"user-menu":"UserMenu_user-menu__v4lpW","dropdown":"UserMenu_dropdown__Wos0n"};